import SampleRegistriesView from './sample-registries-view'

export default SampleRegistriesView
